module.exports = __webpack_public_path__ + "static/media/4.132fe76b.png";